"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichWithScreenContext = void 0;
// analytics-next does not populate context.screen automatically; stamp device + viewport dimensions on every event.
const enrichWithScreenContext = ({ payload, next }) => {
    const context = payload.obj.context ?? (payload.obj.context = {});
    context.screen = {
        ...context.screen,
        width: window.screen.width,
        height: window.screen.height,
        density: window.devicePixelRatio,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
    };
    next(payload);
};
exports.enrichWithScreenContext = enrichWithScreenContext;
